import { useEffect, useState } from "react";

export function showToast(detail) {
  window.dispatchEvent(new CustomEvent("yansh:admin-toast", { detail }));
}

export default function ToastViewport() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const handler = (event) => {
      const id = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
      const next = {
        id,
        tone: event.detail?.tone || "info",
        title: event.detail?.title || "Update",
        message: event.detail?.message || "",
      };

      setToasts((current) => [...current, next]);
      window.setTimeout(() => {
        setToasts((current) => current.filter((item) => item.id !== id));
      }, 2800);
    };

    window.addEventListener("yansh:admin-toast", handler);
    return () => window.removeEventListener("yansh:admin-toast", handler);
  }, []);

  return (
    <div className="toast-stack" aria-live="polite" aria-atomic="true">
      {toasts.map((toast) => (
        <div className={`toast-card toast-${toast.tone}`} key={toast.id}>
          <strong>{toast.title}</strong>
          {toast.message && <span>{toast.message}</span>}
        </div>
      ))}
    </div>
  );
}
